import React from "react";
import InputField from "../input/inputField";

interface Props {
  routeName: string;
  setRouteName: (routeName: string) => unknown;
  vehicleNo: string;
  setVehicleNo: (vehicleNo: string) => unknown;
  licenseNo: string;
  setLicenseNo: (licenseNo: string) => unknown;
  driverName: string;
  setDriverName: (driverName: string) => unknown;
  driverContact: string;
  setDriverContact: (driverContact: string) => unknown;
  transportCode: string;
  setTransportCode: (transportCode: string) => unknown;
}

export const TransportForm = ({
  routeName,
  setRouteName,
  vehicleNo,
  setVehicleNo,
  licenseNo,
  setLicenseNo,
  driverName,
  setDriverName,
  driverContact,
  setDriverContact,
  transportCode,
  setTransportCode,
}: Props) => {
  return (
    <div className="flex flex-col">
      <InputField
        value={transportCode}
        setValue={setTransportCode}
        label="Transport code"
        placeHolder="Enter transport code"
      />

      <InputField
        value={routeName}
        setValue={setRouteName}
        label="Route name"
        placeHolder="Enter route name"
      />

      <InputField
        value={vehicleNo}
        setValue={setVehicleNo}
        label="Vehicle number"
        placeHolder="Enter vehicle number"
      />

      <InputField
        value={driverName}
        setValue={setDriverName}
        label="Driver name"
        placeHolder="Enter driver name"
      />

      <InputField
        value={licenseNo}
        setValue={setLicenseNo}
        label="Lisence number"
        placeHolder="Enter lisence number"
      />

      <InputField
        value={driverContact}
        setValue={setDriverContact}
        label="Driver contact number"
        placeHolder="Enter driver contact number"
      />
    </div>
  );
};
